export default {"src":"/_next/static/media/report.468a5bc1.svg","height":213,"width":190,"blurWidth":0,"blurHeight":0};